import { render } from "./routeData.vue?vue&type=template&id=792427be&scoped=true"
import script from "./routeData.vue?vue&type=script&lang=js"
export * from "./routeData.vue?vue&type=script&lang=js"

import "./routeData.vue?vue&type=style&index=0&id=792427be&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-792427be"]])

export default __exports__